import { useMutation, useQueryClient } from "@tanstack/react-query";

import { profileApi } from "@/features/profile/services/profile.api";

/** Invalidates `["auth", "me"]` too (identity feature's `useCurrentUser`,
 * not just this feature's own `["profile", "me"]`) — a name/avatar change
 * here must also refresh the header's initials/avatar, which reads from
 * that separate query, not this one. */
function invalidateProfileQueries(queryClient: ReturnType<typeof useQueryClient>) {
  void queryClient.invalidateQueries({ queryKey: ["profile", "me"] });
  void queryClient.invalidateQueries({ queryKey: ["auth", "me"] });
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: profileApi.updateMyProfile,
    onSuccess: () => invalidateProfileQueries(queryClient),
  });
}

export function useUploadAvatar() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: profileApi.uploadAvatar,
    onSuccess: () => invalidateProfileQueries(queryClient),
  });
}
